// Migrated from shinshin/'s `schools` table via a fuller basic-info export
// (schools_export_basic.csv, 学校编号/欣欣学校名称/地址 columns), used to populate the
// school dropdown shown when signing up or being created as a 教师, so schoolCode/schoolName
// on the user record match a real, known school rather than free text. 390 schools as of
// this export -- filtered down from the export's 434 rows to only those that carry an
// address, so every school shown here has one (see schoolFilterOption below, which searches
// it). A prior migration only carried a partial export (392 schools, missing every code from
// 366 through 9000, 44 of them also missing an address) -- this file was regenerated from
// schools_export_basic.csv to close that gap; see the matching backend migration that rebuilds
// the `schools` table the same way. The shinshin `schools` table also carries a
// program-partnership status column (变动保留/撤并退出/失联/...) that's specific to shinshin's
// own donor-program tracking and irrelevant here, so it was intentionally not carried over.
export const SCHOOLS = [
  { code: 1, name: "黑龙江省哈尔滨市双城区朝阳乡欣欣小学", address: "黑龙江省哈尔滨双城区胜丰镇中心学校" },
  { code: 2, name: "吉林省白城市镇贲县坦途镇第二中心欣欣小学", address: "吉林省白城市镇赉县坦途镇第二小学校" },
  { code: 3, name: "吉林省通化县快大茂镇欣欣小学", address: "吉林省通化市通化县快大茂镇中心小学" },
  { code: 5, name: "内蒙古乌拉特前旗欣欣希望小学", address: "内蒙古自治区巴彦淖尔市乌拉特前旗乌拉山小学" },
  { code: 6, name: "内蒙古达茂旗欣欣希望小学(汉蒙族)", address: "内蒙古自治区包头市达茂联合旗蒙古族学校" },
  { code: 9, name: "云南省楚雄彝族自治州牟定县青龙乡河节冲欣欣侨心小学", address: "云南省楚雄彝族自治州牟定县凤屯镇河节冲小學" },
  { code: 10, name: "云南省楚雄彝族自治州姚安县光禄镇新村欣欣侨心小学", address: "云南省楚雄彝族自治州姚安县旧城小学" },
  { code: 11, name: "黑龙江省绥化市太平川镇欣欣小学", address: "黑龙江省绥化市北林区太平川镇中心小学校" },
  { code: 12, name: "黑龙江省望奎县恭六欣欣希望小学", address: "黑龙江省绥化市望奎县恭六乡中心小学" },
  { code: 13, name: "黑龙江省哈尔滨市双城区农丰满族锡伯族镇", address: "黑龙江省哈尔滨市双城区农丰满族锡伯族镇" },
  { code: 14, name: "黑龙江省延寿县玉河乡欣欣小学", address: "黑龙江省哈尔滨市延寿县玉河中心校" },
  { code: 16, name: "辽宁省大石桥市水源镇大村村欣欣希望小学", address: "辽宁省营口市大石桥市水源镇九年一贯制学校盖家分校" },
  { code: 17, name: "辽宁省辽阳县灯塔市古树子一匡欣欣希望小学", address: "辽宁省辽阳市灯塔市大河南镇中心小学" },
  { code: 18, name: "辽宁省法库县冯贝堡乡务名屯欣欣希望小学", address: "辽宁省沈阳市法库县冯贝堡镇中心小学" },
  { code: 19, name: "江苏省盐城市射阳县四明小学", address: "江苏省盐城市射阳县四明镇四明小学" },
  { code: 20, name: "湖北省潜江市熊口镇万德固李蕴华伉俪纪念小学", address: "湖北省潜江市熊口镇莲市小学" },
  { code: 22, name: "云南省泸西县旧城镇旧龙寨广恩欣欣小学", address: "云南省红河哈尼族彝族自治州泸西县旧城镇路溪白小学" },
  { code: 23, name: "四川省宜宾市长宁县吴哲儒欣欣小学", address: "四川省宜宾市长宁镇盘村小学" },
  { code: 24, name: "湖南省湘西花垣县花垣镇思谕欣欣小学", address: "湖南省湘西州花垣县花垣镇团结下瓦水小学" },
  { code: 25, name: "重庆市荣昌县清江镇李润如欣欣中心小学", address: "重庆市荣昌区清江镇中心小学" },
  { code: 27, name: "吉林省白城市通榆县开通镇明德欣欣小学", address: "吉林省白城市通榆县开通镇明德小学校" },
  { code: 28, name: "辽宁省灯塔市柳条寨镇三台子村士源欣欣小学", address: "辽宁省辽阳市柳条寨镇中心小学" },
  { code: 29, name: "辽宁省丹东市振安区宋氏欣欣小学", address: "辽宁省丹东市振安区同兴镇同兴镇中心小学" },
  { code: 30, name: "吉林省蛟河市前进乡祖博士欣欣小学", address: "吉林省吉林市蛟河市前进乡九年制学校" },
  { code: 31, name: "福建省武夷山市吴屯乡龚履端欣欣小学", address: "福建省南平市武夷山市吴屯中心小学" },
  { code: 32, name: "湖南省平江县三墩乡振华小学", address: "湖南省岳阳市平江县三墩乡志坪小学" },
  { code: 34, name: "安徽省当涂县湖阳乡大刑欣欣小学", address: "安徽省马鞍山市当涂县湖阳镇大邢小学" },
  { code: 35, name: "四川省南充市西充县同德乡欣欣小学", address: "四川省南充市西充县同德乡小学" },
  { code: 36, name: "山东省烟台市福山区门楼镇梁明初欣欣完小", address: "山东省烟台市福山区门楼兜余小学" },
  { code: 37, name: "辽宁省法库县依牛堡欣欣九年一贯制学校", address: "辽宁省沈阳市法库县依牛堡镇中心小学" },
  { code: 38, name: "吉林省通榆县欣欣实验小学", address: "吉林省白城市通榆县开通镇第二实验小学校" },
  { code: 39, name: "云南省宾川县古底甸尾广恩欣欣小学", address: "云南省大理白族自治州宾川县平顺镇古底完全小学" },
  { code: 40, name: "四川省宜宾市高县蕉村镇文治村欣欣小学", address: "四川省宜宾市高县蕉村镇文治村中心小学" },
  { code: 41, name: "湖南省湘西吉首市排吼乡思谕欣欣小学", address: "湖南省湘西州吉首市排吼思谕欣欣小学" },
  { code: 42, name: "湖南省湘西吉首市河溪镇思谕欣欣小学", address: "湖南省湘西州吉首市河溪镇中心小学" },
  { code: 43, name: "湖南省湘西永顺县塔卧镇广恩欣欣小学", address: "湖南省湘西州永顺县塔卧苏区中心完全小学" },
  { code: 44, name: "湖南省湘西州凤凰县禾库学区芙蓉欣欣学校", address: "湖南省湘西州凤凰县禾库学区芙蓉学校" },
  { code: 45, name: "湖南省常德市汉寿县军山铺镇中学欣欣永嘉综合楼", address: "湖南省常德市汉寿县军山铺镇中学" },
  { code: 46, name: "湖南省石门县磨市镇商溪欣欣学校", address: "湖南省常德市石门县洞国学校" },
  { code: 47, name: "湖南省江华市瑶族自治县大路铺镇兴佳欣欣小学", address: "湖南省永州市江华瑶族自治县大路铺镇兴佳完全小学" },
  { code: 48, name: "湖南省长沙县白沙乡杨隆佑二小", address: "湖南省长沙市长沙县开慧镇同盟小学" },
  { code: 49, name: "湖南省湘乡市育段乡育仁欣欣小学", address: "湖南省湘潭市湘乡市育塅示范学校" },
  { code: 50, name: "湖南省湘西永顺县石堤西湖片瑞云欣欣小学", address: "湖南省湘西州永顺县石堤镇中心完全小学" },
  { code: 51, name: "湖南省湘西花垣县龙潭镇广恩欣欣小学", address: "湖南省湘西州花垣县龙潭镇中心小学" },
  { code: 52, name: "湖南省湘西吉首市矮寨镇广恩欣欣小学", address: "湖南省湘西州吉首市矮寨镇广恩欣欣小学" },
  { code: 53, name: "湖南省湘西保靖县杨隆祜三小", address: "湖南省湘西州保靖县杨隆祜三小" },
  { code: 54, name: "湖南省湘西芦溪县上堡乡梁继焜纪念学校", address: "湖南省湘西州泸溪县梁继焜纪念小学" },
  { code: 55, name: "山东省东平县银山法华欣欣小学", address: "山东省泰安市东平县银山实验学校" },
  { code: 57, name: "四川省阿垻州九寨沟县安乐乡林氏欣欣小学", address: "四川省阿坝藏族羌族自治州九寨沟县第三小学" },
  { code: 58, name: "宁夏中卫市海原县关桥瓦窑河于杏龄欣欣小学", address: "宁夏回族自治区中卫市海原县关桥中心小学" },
  { code: 59, name: "甘肃省玉门市柳河乡蘑菇滩庆华欣欣小学", address: "甘肃省酒泉市玉门市柳河镇学校" },
  { code: 60, name: "甘肃省敦煌市杨家桥乡鸣山兆基纪念欣欣小学", address: "甘肃省酒泉市敦煌市杨家桥乡鸣山小学" },
  { code: 61, name: "四川省筠连县罗昔安欣欣小学", address: "四川省宜宾市筠连县巡司镇民主小学" },
  { code: 62, name: "青海省互助土族自治县双树乡大沟信望爱欣欣小学", address: "青海省海东市互助土族自治县塘川镇大沟教学点" },
  { code: 63, name: "青海省西宁市湟中区土门关乡业隆达人欣欣小学", address: "青海省西宁市湟中区土门关乡土门关小学" },
  { code: 64, name: "青海省西宁市湟中区田家寨什张家广恩欣欣小学", address: "青海省西宁市湟中区田家寨什张家学校" },
  { code: 65, name: "青海省乐都县芦化乡营盘湾欣欣小学", address: "青海省海东市乐都区芦花乡中心学校" },
  { code: 66, name: "青海省乐都县马厂乡孟家湾广恩欣欣中心学校", address: "青海省海东市乐都区马厂乡中心学校" },
  { code: 68, name: "宁夏海原县西安乡小河华华欣欣小学", address: "宁夏回族自治区中卫市西安镇中心小学" },
  { code: 69, name: "宁夏海原县西安乡付套华华欣欣小学", address: "宁夏回族自治区中卫市海原县西安镇中心小学" },
  { code: 70, name: "宁夏海原县关庄乡北岔荣恩欣欣小学", address: "宁夏回族自治区中卫市海原县关庄乡九年一贯制学校" },
  { code: 71, name: "辽宁省辽阳县隆昌镇得胜宪章欣欣小学", address: "辽宁省辽阳市辽阳县隆昌镇九年一贯制学校" },
  { code: 72, name: "安徽省休宁县万安镇徽光村缪伊洄欣欣小学", address: "安徽省黄山市休宁县万安镇中心小学" },
  { code: 73, name: "安徽省当涂县黄池镇欣欣中心小学", address: "安徽省马鞍山市当涂县黄池实验学校" },
  { code: 74, name: "江苏省扬州市宝应县柳堡镇中心小学", address: "江苏省扬州市宝应县柳堡镇中心小学" },
  { code: 75, name: "西藏洛扎县扎日乡白沙村白沙怀恩欣欣小学", address: "西藏山南市洛扎县扎日乡白沙怀恩欣欣小学" },
  { code: 76, name: "辽宁省安山市岫岩县大营子镇王家堡村欣欣小学", address: "辽宁省安山市岫岩满族自治县大营子镇中心校" },
  { code: 78, name: "湖南省汉寿县军山铺镇欣欣小学", address: "湖南省常德市汉寿县军山铺镇中学" },
  { code: 79, name: "云南省昭通市威信县家祺小学", address: "云南省昭通市威信县扎西镇稼祺欣欣小学" },
  { code: 81, name: "甘肃省玉门市玉门镇团结文才欣欣完全小学", address: "甘肃省酒泉市玉门市第三小学" },
  { code: 82, name: "湖南省湘西吉首市马颈坳镇育民欣欣小学", address: "湖南省湘西州吉首市马颈坳镇团结小学" },
  { code: 83, name: "江西省奉新县溜头乡广恩欣欣第一小学", address: "江西省宜春市柳溪学校东庄小学" },
  { code: 84, name: "江西省奉新县冯川镇广恩欣欣第二小学", address: "江西省宜春市奉新县冯川镇广恩欣欣第二小学" },
  { code: 85, name: "江西省奉新县冯川镇思谕第一欣欣小学", address: "江西省宜春市奉新县冯川镇思谕第一欣欣小学" },
  { code: 86, name: "江西省奉新县柳溪乡思谕第二欣欣小学", address: "江西省宜春市奉新县柳溪乡柳溪学校" },
  { code: 87, name: "广西壮族自治区防城十万山华侨林场垌平陈林若星欣欣小学", address: "广西壮族自治区省防城港市十万山瑶族乡垌平小学" },
  { code: 88, name: "山东省微山县留庄镇桥上村梁明初欣欣小学", address: "山东省济宁市微山县留庄镇桥上小学" },
  { code: 89, name: "青海省互助土族自治县东沟乡卡子修贞欣欣小学", address: "青海省海东市互助土族自治县东沟乡卡子修贞欣欣小学" },
  { code: 92, name: "河南省巩义市南河渡镇欣欣中心小学", address: "河南省郑州市巩义市河洛镇香玉小学" },
  { code: 95, name: "吉林白城通榆县向海乡高氏欣欣中心小学", address: "吉林省白城市通榆县向海蒙古族乡向海学校" },
  { code: 96, name: "湖南省湘西花垣县长乐乡以琳欣欣小学", address: "湖南省湘西州花垣县长乐乡中心小学" },
  { code: 97, name: "湖南省湘西龙山县石羔镇飞鹏欣欣小学", address: "湖南省湘西州龙山县石羔镇飞鹏欣欣小學" },
  { code: 98, name: "湖南省湘西永顺县青坪镇广恩欣欣小学", address: "湖南省湘西州永顺县青坪镇九年制学校" },
  { code: 99, name: "湖南省湘西龙山县召市镇广恩欣欣小学", address: "湖南省湘西州龙山县召市镇前卫片完全小學" },
  { code: 100, name: "湖南省湘西吉首市双塘镇仲浩欣欣小学", address: "湖南省湘西州吉首市双塘中心完小" },
  { code: 101, name: "湖南省湘西吉首市白岩乡思谕小学", address: "湖南省湘西州吉首市马颈坳镇白岩小学" },
  { code: 102, name: "湖南省湘西古丈县草潭乡龙飞欣欣小学", address: "湖南省湘西州古丈县岩头寨镇草潭完小" },
  { code: 103, name: "湖南省湘西吉首市排绸乡标锦龙飞欣欣小学", address: "湖南省湘西州吉首市标锦龙飞欣欣小学" },
  { code: 104, name: "湖南省湘西凤凰县禾库镇以琳欣欣小学", address: "湖南省湘西州凤凰县禾库镇以琳欣欣小學" },
  { code: 105, name: "湖南省桃江县浮邱山广恩欣欣小学", address: "湖南省益阳市浮邱山乡广恩欣欣小学" },
  { code: 106, name: "湖南省常德市鼎城区逆江坪乡杨隆祜欣欣小学", address: "湖南省常德市鼎城区花岩溪镇逆江坪中心小学" },
  { code: 107, name: "湖南省湘西泸溪县武溪镇乃新欣欣小学", address: "湖南省湘西州泸溪县武溪镇中学" },
  { code: 108, name: "湖南省常德市临澧县九里乡身影欣欣小学", address: "湖南省常德市临澧县九裡鄉身影欣欣小學" },
  { code: 109, name: "湖南省常德市桃源县青林回族维吾尔族乡智诚欣欣学校", address: "湖南省常德市桃源县青林回族维吾尔族乡中心小学" },
  { code: 110, name: "四川省南充市嘉陵区安平欣欣小学", address: "四川省南充市嘉陵区安平镇安平小学" },
  { code: 111, name: "四川遂宁市射洪县官升镇林氏欣欣小学", address: "四川省遂宁市射洪市官升学校" },
  { code: 112, name: "四川省宜宾市宜宾县合什镇罗彤云欣欣小学", address: "四川省宜宾市叙州区合什学校征远小学校区" },
  { code: 113, name: "四川南充市高坪区胜观镇星光欣欣小学", address: "四川省南充市高坪区胜观中小学" },
  { code: 115, name: "湖北省孝感市孝南区杨店镇欣欣小学", address: "湖北省孝感市孝南区杨店镇第一小学" },
  { code: 116, name: "辽宁省葫芦岛连山区台集屯镇常玉章纪念欣欣小学", address: "辽宁省葫芦岛市南票区台集屯镇九年一贯制学校" },
  { code: 117, name: "黑龙江省绥化市明水县永久欣欣中心小学", address: "黑龙江省绥化市明水县永久欣欣中心小学" },
  { code: 118, name: "辽宁省朝阳市喀左县平房子镇小营欣欣小学", address: "辽宁省朝阳市喀左县平房子镇小营欣欣小学" },
  { code: 119, name: "辽宁省阜新县八家子乡八家子欣欣学校", address: "辽宁省阜新市阜新蒙古族自治县八家子镇八家子学校" },
  { code: 120, name: "内蒙古苏尼特右旗阿其图乌拉苏木欣欣小学", address: "内蒙古苏尼特右旗阿其图乌拉苏木 苏尼特右旗蒙古族小学" },
  { code: 121, name: "内蒙古鄂伦春旗托扎敏乡欣欣小学", address: "内蒙古自治区呼伦贝尔市鄂伦春自治旗托扎敏学校" },
  { code: 122, name: "内蒙古赤峰市翁牛特旗山咀子乡炎亮欣欣小学", address: "内蒙古自治区赤峰市翁牛特旗乌丹镇山咀子小学" },
  { code: 123, name: "内蒙古鄂尔多斯市杭锦旗四十里梁镇全仁欣欣小学", address: "内蒙古自治区鄂尔多斯市杭锦旗塔然高勒乡杭锦旗实验小学" },
  { code: 124, name: "青海省循化撒拉族自治县积石镇玉堂欣欣小学", address: "青海省海东市循化县积石镇循阳学校" },
  { code: 126, name: "青海省大通县长宁镇诺发欣欣完全小学", address: "青海省西宁市大通县长宁镇诺发欣欣完全小學" },
  { code: 127, name: "青海省互助土族自治县双树乡诺发欣欣小学", address: "青海省海东市互助土族自治县双树乡诺发欣欣小學" },
  { code: 128, name: "青海省乐都县中垻乡中心小学 欣欣教学楼", address: "青海省海东市中坝藏族乡中坝中心学校" },
  { code: 129, name: "青海省互助土族自治县东沟乡谢瑞棠欣欣小学", address: "青海省海东市互助土族自治县东沟乡昝扎谢瑞棠欣欣完全小学" },
  { code: 130, name: "黑龙江省黑河市爱辉县西峰山欣欣中心学校", address: "黑龙江省黑河市爱辉区西峰山乡学校" },
  { code: 131, name: "甘肃省瓜州县七墩回族东乡族乡欣欣学校", address: "甘肃省酒泉市瓜州县七墩回族东乡族乡中心小学" },
  { code: 132, name: "甘肃省玉门市下西号乡石河子春晖欣欣小学", address: "甘肃省酒泉市玉门市下西号镇下西号学校" },
  { code: 133, name: "甘肃省酒泉市肃州区益民林氏欣欣小学", address: "甘肃省酒泉市肃州区上坝镇移民农场小学" },
  { code: 134, name: "甘肃省酒泉市肃州区丰乐乡林氏欣欣小学", address: "甘肃省酒泉市肃州区丰乐乡丰乐中心小学" },
  { code: 135, name: "甘肃省敦煌市黄渠乡清水村炎培欣欣小学", address: "甘肃省酒泉市敦煌市黄渠镇黄渠中学" },
  { code: 136, name: "甘肃省敦煌市七里镇国任欣欣小学", address: "甘肃省酒泉市敦煌市七里镇中学" },
  { code: 137, name: "甘肃省酒泉市金塔县中东镇黑树窝王氏欣欣小学", address: "甘肃省酒泉市金塔县中东镇中东小学" },
  { code: 138, name: "宁夏西吉县吉强镇苟庄李实欣欣小学", address: "宁夏回族自治区固原市吉强镇苟庄李实欣欣小学" },
  { code: 139, name: "宁夏中卫市乐台树人欣欣小学", address: "宁夏回族自治区中卫市沙坡区永康镇乐台小学" },
  { code: 140, name: "宁夏固原市原州区甘城乡乔畔以琳欣欣小学", address: "宁夏回族自治区中卫市海原县甘城乡乔畔小学" },
  { code: 141, name: "宁夏固原市原州区甘城乡石景以琳欣欣小学", address: "宁夏回族自治区中卫市海原县甘城乡甘城小学" },
  { code: 142, name: "宁夏彭阳县孟塬乡草滩周氏欣欣小学", address: "宁夏回族自治区固原市彭阳县孟塬乡草滩村完全小学" },
  { code: 143, name: "江西省奉新县干洲镇思谕欣欣三小学", address: "江西省宜春市奉新县思谕欣欣第三学校" },
  { code: 144, name: "贵州台江县老屯乡知行小学欣欣综合楼", address: "贵州省黔东南州台江縣老屯鄉知行欣欣希望小學" },
  { code: 145, name: "云南威信县双河乡天池村彭周欣欣小学", address: "云南省昭通市威信县双河乡苗族彝族天池欣欣希望小学" },
  { code: 146, name: "湖北省钟祥市双河镇李济博士伉俪纪念欣欣小学", address: "湖北省荆门市钟祥市双河镇双河小学" },
  { code: 147, name: "江苏宝应县城中欣欣小学", address: "江苏省扬州市宝应县城中小学" },
  { code: 148, name: "江西省奉新县澡下镇长青村书琴欣欣小学", address: "江西省宜春市奉新县澡下镇书琴欣欣小学" },
  { code: 149, name: "福建省仙游县园庄镇后蔡村介明欣欣小学", address: "福建省莆田市仙游县园庄镇后蔡小学" },
  { code: 150, name: "河南省巩义市芝田镇怡安欣欣中心小学", address: "河南省郑州市巩义市芝田镇中心小学" },
  { code: 152, name: "山东省高密市注泃镇庆葵欣欣小学", address: "山东省潍坊市高密市注沟现代农业发展区庆葵欣欣小学" },
  { code: 153, name: "四川省雅安市宝兴县灵关欣欣学校", address: "四川省雅安市宝兴县灵关镇毓秀新区宝灵路67号" },
  { code: 154, name: "四川长宁县开佛乡吴绍珍欣欣小学", address: "四川省宜宾市长宁县长宁镇开佛义务教育学校民主小学" },
  { code: 156, name: "山东省烟台市张格庒乡牟焕经欣欣完全小学", address: "山东省烟台市福山区张格庄镇张格庄小学" },
  { code: 157, name: "山东省邹平县码头镇黄蔡若兰欣欣小学", address: "山东省滨州市邹平县码头镇黄蔡若兰欣欣小学" },
  { code: 158, name: "江西省南昌市新建区大塘坪乡长胜欣欣小学", address: "江西省南昌市新建区大塘坪乡长胜小学" },
  { code: 161, name: "黑龙江伊春市西林区欣欣小学", address: "黑龙江省伊春市伊春市西林区西林小学" },
  { code: 163, name: "山西省晋中市榆社县永生欣欣中心小学", address: "山西省晋中市榆社县西马乡中心校" },
  { code: 164, name: "安徽省桐城市金神镇平岗欣欣小学", address: "安徽省安庆市桐城市金神中心小学" },
  { code: 166, name: "湖南省湘西凤凰县三拱桥乡乡音欣欣小学", address: "湖南省湘西州凤凰县三拱桥学区泡水教学点" },
  { code: 167, name: "河南省周口市淮阳县府君庙乡音欣欣小学", address: "河南省周口市淮阳县刘振屯乡府君庙小学" },
  { code: 168, name: "山西省忻州市宁武县东寨荣恩欣欣小学", address: "山西省忻州市武县东寨完全小学" },
  { code: 170, name: "吉林省吉林市船营越北镇欣欣小学", address: "吉林省吉林市船营区越北镇沙河子村" },
  { code: 172, name: "辽宁省锦州市北镇市大屯乡欣欣中心小学", address: "辽宁省锦州市北镇大屯乡欣欣中心小学" },
  { code: 173, name: "辽宁省鞍山市岫岩县大营子镇陶家隈欣欣小学", address: "辽宁省鞍山市大营子镇陶家隈欣欣小学" },
  { code: 174, name: "海南省三亚市吉阳区红沙小学广恩欣欣小学", address: "海南省三亚市吉阳区红沙小学" },
  { code: 175, name: "青海省互助土家族自治县丹麻镇索布滩乃安欣欣小学", address: "青海省海东市互助土族自治县丹麻镇索卜滩乃安欣欣小学" },
  { code: 176, name: "湖南省新宁县安山许德期欣欣中心小学", address: "湖南省邵阳市新宁县安山乡中心小学" },
  { code: 177, name: "湖南省永州市蓝山县汇源瑶族乡光明欣欣小学", address: "湖南省永州市蓝山县汇源中心小学" },
  { code: 178, name: "湖南省郴州市桂东县宝康欣欣小学", address: "湖南省桂东县沤江镇东华社区东街188号" },
  { code: 179, name: "湖南省衡阳市衡阳县富田李绍姒欣欣完小", address: "湖南省衡阳市衡阳县富田李紹姒欣欣完小" },
  { code: 180, name: "湖南省平江县长寿镇广恩欣欣中心完小", address: "湖南省岳阳市平江县长寿镇太平学校" },
  { code: 181, name: "湖南省岳阳市平江县长寿镇新民欣欣小学", address: "湖南省岳阳市平江县长寿镇中心学校" },
  { code: 182, name: "湖南省湘潭市湘乡县月山镇栗山乡许德期欣欣学校", address: "湖南省湘潭市湘乡市月山镇栗山许德期欣欣学校" },
  { code: 183, name: "江西省南昌市进贤县罗溪镇李何喜欣欣小学", address: "江西省南昌市进贤县罗溪镇欣欣小学" },
  { code: 184, name: "江西宜春市上高县敖山镇欣欣小学", address: "江西省宜春市上高县敖山镇中心小学" },
  { code: 185, name: "江西省宜春市甘坊镇广恩欣欣学校", address: "江西省宜春市奉新县甘坊学校" },
  { code: 186, name: "甘肃永登县柳树乡欣欣民族小学", address: "甘肃省兰州市永登县柳树镇复兴小学" },
  { code: 187, name: "甘肃省临夏县漠泥沟乡胡英祥欣欣小学", address: "甘肃省临夏回族自治州临夏县漠泥沟乡胡英祥欣欣小学" },
  { code: 188, name: "甘肃省定西市安定区称钩驿禧福欣欣小学", address: "甘肃省定西市安定区称钩驿中心学校" },
  { code: 189, name: "贵州省凯里市大风洞乡思谕欣欣小学", address: "贵州省黔东南州凯里市大风洞乡老君寨思谕欣欣小学" },
  { code: 190, name: "贵州省印江自治县罗场乡博爱欣欣小学", address: "贵州省铜仁市印江县罗场乡两河完全小学" },
  { code: 191, name: "湖南省湘西凤凰县落潮井乡唐家桥片思谕欣欣完小", address: "湖南省湘西州凤凰县落潮井学区塘家桥思谕小学" },
  { code: 192, name: "湖南省湘西凤凰县水打田乡红星片仲浩欣欣完全小学", address: "湖南省湘西州凤凰县红星片仲浩欣欣小学" },
  { code: 193, name: "湖南省湘西泸溪县谭溪镇炳麟欣欣中学", address: "湖南省湘西州泸溪县潭溪镇炳麟欣欣中學" },
  { code: 194, name: "湖南省湘西永顺县泽家乃新欣欣九年制学校", address: "湖南省湘西州永顺县泽家镇九年制学校" },
  { code: 195, name: "湖南省湘西吉首市社塘坡禧福欣欣学校", address: "湖南省湘西州吉首市社塘坡学校" },
  { code: 196, name: "湖南省湘西吉首市丹青乃新欣欣中学", address: "湖南省湘西州吉首市丹青镇中心完小（乃新中学）" },
  { code: 197, name: "湖南省湘西花垣县大龙洞乡李绍姒欣欣中心小学", address: "湖南省湘西州花垣縣大龍洞鄉李紹姒欣欣中心小學" },
  { code: 199, name: "山西省榆次区东赵乡东赵欣欣学校", address: "山西省晋中市榆次区东赵乡东赵学校" },
  { code: 200, name: "山西省忻州市代县阳明堡镇古城周秀清欣欣中心小学", address: "山西省忻州市代县阳明堡镇古城小学" },
  { code: 201, name: "陕西省延安市洛川县交口河镇林行规欣欣中心小学", address: "陕西省延安市交口河镇中心小学" },
  { code: 202, name: "陕西省延安市富县直罗镇萃英欣欣中心小学", address: "陕西省延安市富县直罗镇中心小学" },
  { code: 203, name: "陕西省旬阳县桂花乡九零学社欣欣九年制学校", address: "陕西省安康市旬阳县吕河镇桂花九年制学校" },
  { code: 204, name: "陕西洛南县永丰镇凯文欣欣完全小学", address: "陕西省商洛市洛南县永丰镇凯文欣欣完全小学" },
  { code: 205, name: "陕西省商洛市柞水县杏坪镇欣欣中心校", address: "陕西省商洛市柞水县杏坪镇中心校" },
  { code: 206, name: "广西壮族自治区容县松山镇欣欣小学", address: "广西壮族自治区省玉林市容县松山镇慈堂中心小学" },
  { code: 207, name: "安徽芜湖市繁昌县繁阳镇文白欣欣小学", address: "安徽省芜湖市繁昌县横山中心小学" },
  { code: 208, name: "四川省达州市通川区金石镇林氏欣欣中心学校", address: "四川省达州市通川区金石镇中心学校" },
  { code: 209, name: "四川省资阳市安岳县兴隆镇左家坪林氏欣欣学校", address: "四川省资阳市安岳县左家坪九年制学校" },
  { code: 210, name: "四川省巴中市巴州区茶垻镇金鱼村林氏欣欣小学", address: "四川省巴中市恩阳区茶坝镇杨柳村小学" },
  { code: 211, name: "四川达州市通川区东岳乡中心校欣欣教学楼", address: "四川省达州市通川区东岳镇中心校" },
  { code: 212, name: "四川省宜宾市隆兴乡天琪欣欣小学", address: "四川省宜宾市叙州区隆兴乡水口小学校" },
  { code: 213, name: "湖南省湘西凤凰县官庄乡溪口梁继焜欣欣完小", address: "湖南省湘西州凤凰县官庄乡溪口小学" },
  { code: 214, name: "湖南省湘西龙山县水沙坪乡信望爱欣欣中心小学", address: "湖南省湘西州龙山县茅坪乡九年制学校" },
  { code: 216, name: "山东东平县戴庙镇法华欣欣完全小学", address: "山东省泰安市东平县戴庙镇中心小学" },
  { code: 217, name: "安徽省当涂县姑熟镇藏汉欣欣中心小学", address: "安徽省马鞍山市当涂县藏汉中心学校" },
  { code: 218, name: "湖北阳新县兴国镇银山欣欣小学", address: "湖北省黄石市阳新经济开发区银山完全小学" },
  { code: 219, name: "河南省驻马店遂平县槐树乡金台欣欣小学", address: "河南省驻马店市遂平县槐树乡大营小学" },
  { code: 220, name: "湖北省阳新县太子镇瑞兰欣欣完全小学", address: "湖北省黄石市阳新县太子鎮大塘完全小學" },
  { code: 221, name: "四川省简阳市新市镇仁义村明山欣欣小学", address: "四川省成都市简阳市怀远九年义务教育学校" },
  { code: 222, name: "吉林省辽源矿务局实验文祥欣欣小学", address: "吉林省辽源市西安区第三实验小学" },
  { code: 223, name: "黑龙江省双鸭山市集贤县兴安乡欣欣小学", address: "黑龙江省双鸭山市集贤县兴安中心校" },
  { code: 224, name: "重庆市万州区长滩镇瑞生欣欣小学", address: "重庆市万州区长滩镇瑞生欣欣小學" },
  { code: 225, name: "山东省阳信县水落坡乡长庄艺文欣欣小学", address: "山东省滨州市阳信县水落坡镇长庄小学" },
  { code: 226, name: "湖北省十堰市丹江口市丁家营镇渭川欣欣中心小学", address: "湖北省十堰市丹江口市丁家营镇小学" },
  { code: 227, name: "湖南省湘西湘西吉首市吉首乡思谕欣欣小学", address: "湖南省湘西州吉首市思諭欣欣小學" },
  { code: 228, name: "湖南省湘西花垣县民乐镇仲浩欣欣中心小学", address: "湖南省湘西州花垣县民乐镇中心小学" },
  { code: 229, name: "湖南省永州市江永县潇浦镇塘背光明欣欣小学", address: "湖南省永州市江永县潇浦镇第三小学" },
  { code: 230, name: "湖南省永州市江华瑶族自治州白芒营镇李绍姒欣欣小学", address: "湖南省永州市江华瑶族自治州白芒营镇中心小学" },
  { code: 231, name: "湖南省望城县茶亭镇茶亭焦德孝欣欣小学", address: "湖南省长沙市望城茶亭小学" },
  { code: 232, name: "甘肃武威市古浪县定宁镇欣欣中心小学", address: "甘肃省武威市古浪县定宁中心小学" },
  { code: 233, name: "甘肃临夏州九年制坪庒欣欣实验中学", address: "甘肃省临夏回族自治州东乡族自治县坪庄乡坪庄学校" },
  { code: 235, name: "甘肃临夏州东乡县果园镇九年制果园中学欣欣小学", address: "甘肃省临夏回族自治州东乡县果园镇九年制果园中学" },
  { code: 236, name: "甘肃临夏州东乡县董岭乡董家岭欣欣小学", address: "甘肃省临夏回族自治州临夏县东乡族自治县董家岭小学" },
  { code: 237, name: "甘肃临夏州临夏市南龙镇四家嘴欣欣小学", address: "甘肃省临夏回族自治州临夏市南龙镇四家嘴小学" },
  { code: 238, name: "甘肃临夏县麻尼寺沟韩家门欣欣小学", address: "甘肃省临夏回族自治州临夏县麻尼寺沟乡韩家门小学" },
  { code: 239, name: "甘肃临夏县麻尼寺沟乡郭东山欣欣小学", address: "甘肃省临夏回族自治州临夏县麻尼寺沟乡郭东山欣欣小学" },
  { code: 240, name: "甘肃省临夏县营滩乡永胜欣欣小学", address: "甘肃省临夏回族自治州临夏县营滩乡永胜小学" },
  { code: 242, name: "甘肃临夏州临夏市抱罕镇后杨欣欣小学", address: "甘肃省临夏回族自治州临夏市抱罕镇后杨欣欣小学" },
  { code: 243, name: "山西忻州静乐县康家会镇尚琳欣欣中心小学", address: "山西省忻州市静乐县康家会小学" },
  { code: 245, name: "山西阳泉市孟县梁家寨大崔家庄健博欣欣小学", address: "山西省阳泉市孟县梁家寨大崔家庄健博欣欣小学" },
  { code: 247, name: "山西晋城市陵川县六泉乡六泉欣欣中心小学", address: "山西省晋城市陵川县六泉乡六泉小学" },
  { code: 249, name: "陕西柞水县红岩寺镇卉萌欣欣小学", address: "陕西省商洛市柞水县红岩寺镇卉万青小学" },
  { code: 250, name: "安徽省黄山市歙县霞江竞民欣欣小学", address: "安徽省黄山市歙县上丰中心学校霞江教学点" },
  { code: 251, name: "安徽省固镇县任桥镇姚毓霖欣欣小学", address: "安徽省蚌埠市固镇官沟小学" },
  { code: 252, name: "山东枣庄市陈山村法华欣欣小学", address: "山东省枣庄市陈山法华欣欣小学" },
  { code: 253, name: "贵州黔南州长顺县长寨镇扁木欣欣小学", address: "贵州省黔南州长顺县长寨街道同笋小学" },
  { code: 254, name: "湖南省湘西龙山县召市镇欣欣中心小学", address: "湖南省湘西州龙山县召市镇欣欣中心小学" },
  { code: 255, name: "安徽潜山县黄铺镇牌楼范苑声欣欣中心小学", address: "安徽省安庆市潜山县牌楼中心小学" },
  { code: 256, name: "安徽马鞍山市龙泉欣欣中心小学", address: "安徽省马鞍山市博望区丹阳镇龙山村梨园" },
  { code: 258, name: "四川宜宾市叙州区龙池乡光龙村云英欣欣小学", address: "四川省宜宾市龙池乡光龙村小学校" },
  { code: 261, name: "四川巴中市南讧县黑潭乡樟木村欣欣小学", address: "四川省巴中市南讧县黑潭乡樟木村小学" },
  { code: 262, name: "广西壮族自治区金秀县罗香乡李门欣欣中心小学", address: "广西壮族自治区省来宾市金秀瑶族自治县罗香中心校" },
  { code: 263, name: "山西省五台县陈家庒乡环椿坪慧海欣欣小学", address: "山西省忻州市五台县陈家庄乡环椿坪小学" },
  { code: 266, name: "贵州省铜仁市桐木坪乡卜口欣欣中心小学", address: "贵州省铜仁市碧江区桐木坪乡卜口中心小学" },
  { code: 267, name: "黑龙江省齐齐哈尔市梅里斯达斡尔族区共和兆明欣欣小学", address: "黑龙江省齐齐哈尔市梅里斯达斡尔族区共和民族中心学校" },
  { code: 268, name: "安徽省和县张家集文白欣欣小学", address: "安徽省马鞍山市和县香泉镇张家集小学" },
  { code: 269, name: "陕西省榆林市靖边县阳光林韬欣欣完全小学", address: "陕西省榆林市靖边县第十三小学" },
  { code: 270, name: "湖南省益阳市桃江县三堂街镇李绍姒欣欣完全小学", address: "湖南省益阳市桃江县三堂街镇合水桥完全小学" },
  { code: 271, name: "湖北鄂州市梁子湖区沼山镇欣欣小学", address: "湖北鄂州市梁子湖区沼山镇海博实验学校" },
  { code: 272, name: "湖北省黄石市阳新县兴国镇宝塔村廷珩欣欣学校", address: "湖北省黄石市阳新县兴国镇宝塔学校" },
  { code: 273, name: "湖北汉川汈汊湖水科所方李邦琴欣欣小学", address: "湖北省孝感市汉川市刁汊湖水科所中心小学" },
  { code: 274, name: "山西省晋中市楡次区紫坑德贤慧欣欣小学", address: "山西省晋中市榆次区庄子乡紫坑小学" },
  { code: 276, name: "贵州省黔东南州三穗县滚马乡健博欣欣综合楼", address: "贵州省黔东南州三穗县滚马乡中心小学" },
  { code: 277, name: "贵州省六盘水市六枝特区县陇脚布依族乡月亮河贝克欣欣小学", address: "贵州省六盘水市六枝特区县陇脚布依族乡月亮河贝克欣欣小学" },
  { code: 278, name: "贵州省六盘水市六枝特区折溪乡中寨贝克欣欣小学", address: "贵州省六盘水市六枝特区月亮河乡中寨小学" },
  { code: 279, name: "贵州省安顺市西秀区黄腊亲晖欣欣小学", address: "贵州省安顺市西秀区黄腊乡黄腊民族小学" },
  { code: 280, name: "青海省互助县加定镇加塘村继羽中心小学", address: "青海省海东市互助土族自治县加定镇加塘村继羽中心小学" },
  { code: 281, name: "安徽省桐城市新渡镇芦圩慈晖欣欣小学", address: "安徽省安庆市桐城市新渡镇新安小学" },
  { code: 282, name: "贵州贵阳龙里县羊场镇国才欣欣小学", address: "贵州省黔南州龙里县湾滩河镇羊场小学" },
  { code: 283, name: "广西壮族自治区富川瑶族自治县富阳镇香士欣欣完小", address: "广西壮族自治区省贺州市富川瑶族自治县富阳镇西屏完全小学" },
  { code: 284, name: "广西壮族自治区百色市乐业县同乐镇武称李维新欣欣小学", address: "广西壮族自治区省百色市乐业县同乐镇武称小学" },
  { code: 285, name: "广西壮族自治区玉林市兴业县龙安镇六霍村才德欣欣小学", address: "广西壮族自治区省玉林市兴业县龙安镇六霍村才德欣欣小学" },
  { code: 286, name: "广西壮族自治区忻城县思练镇德慧欣欣小学", address: "广西壮族自治区省来宾市忻城县思练镇中心小学" },
  { code: 287, name: "广西壮族自治区三江侗族自治县梅林乡新民村启宏欣欣小学", address: "广西壮族自治区省柳州市三江侗族自治县梅林乡新民小学" },
  { code: 288, name: "山东省济宁市曲阜市陵城镇小学", address: "山东省济宁市曲阜市陵城镇小学" },
  { code: 289, name: "山东省潍坊市临朐县上林镇张梦桥欣欣小学", address: "山东省潍坊市临朐县山旺镇桲林小学" },
  { code: 290, name: "河南省驻马店市驿城区板桥镇贝克欣欣小学", address: "河南省驻马店市驿城区板桥镇马冲小学" },
  { code: 292, name: "四川省巴中市南江县高塔镇金盆硅谷女性欣欣小学", address: "四川省巴中市南江县高塔镇金盆小学" },
  { code: 293, name: "重庆市万州区恒合瑞英欣欣民族中心小学", address: "重庆市万州区恒合土家族乡民族中心小学" },
  { code: 294, name: "江苏省沛县朱寨镇欣欣中心小学", address: "江苏省徐州市沛县朱寨镇中心小学" },
  { code: 295, name: "新疆洛浦县杭桂乡欣欣中心小学", address: "新疆维吾尔族自治区和田地区洛浦县杭桂镇中心小学第一分校" },
  { code: 297, name: "四川省宜宾县高场镇崇实欣欣小学", address: "四川省宜宾市叙州区高场镇黄伞小学校" },
  { code: 298, name: "四川叙州区双龙镇金山村林氏欣欣小学", address: "四川省宜宾市叙州区双龙镇金山村小学校" },
  { code: 300, name: "陕西省渭南市澄城县王庄镇耀扬欣欣小学", address: "陕西省渭南市澄城县王庄镇中心学校" },
  { code: 301, name: "陕西省咸阳市彬县龙高镇陆南山欣欣小学", address: "陕西省咸阳市彬县龙高镇龙马小学" },
  { code: 302, name: "湖南省湘西吉首市矮寨镇克让欣欣小学", address: "湖南省湘西州吉首市矮寨镇民族完小" },
  { code: 303, name: "湖南省湘西吉首市白岩乡真光欣欣中心完小", address: "湖南省湘西州吉首市白岩鄉真光欣欣中心完小" },
  { code: 304, name: "吉林省四平市铁东区叶赫满族镇果子欣欣小学", address: "吉林省四平市铁东区叶赫满族镇中心小学" },
  { code: 305, name: "湖北省鄂州市华容区蒲团乡横山欣欣小学", address: "湖北省鄂州市华容区蒲团乡横山中心小学" },
  { code: 306, name: "湖北省黄冈市英山县孔家坊乡欣欣学校", address: "湖北省黄冈市英山县孔家坊乡同心学校" },
  { code: 307, name: "湖北省十堰市郧县杨溪铺镇晋山琳峰欣欣完全小学", address: "湖北省十堰市郧阳区杨溪铺镇青龙泉中心小学" },
  { code: 308, name: "湖南省岳阳市君山区西城九公里程蓉菁欣欣小学", address: "湖南省岳阳市君山区西城办事处九公里小学" },
  { code: 309, name: "湖南省株洲市茶陵县舲舫乡中心小学", address: "湖南省株洲市茶陵县舲舫乡中心小学" },
  { code: 311, name: "山东省曲阜市王庄乡高雨辰欣欣小学", address: "山东省济宁市曲阜市王庄镇辛庄小学" },
  { code: 312, name: "山西省运城市新绛县万安镇谦益欣欣小学", address: "山西省运城市新绛县万安镇万安学校" },
  { code: 313, name: "广西壮族自治区爱洞乡陈氏欣欣小学", address: "广西壮族自治区省河池市环江县长美乡爱洞陈氏小学" },
  { code: 314, name: "贵州省万山特区高楼坪侗族乡民族元德欣欣中心小学", address: "贵州省铜仁市万山区高楼坪侗族乡民族中心完全小学" },
  { code: 315, name: "安徽省桐城市双港镇根祥欣欣小学", address: "安徽省安庆市双港镇双港中心小学" },
  { code: 316, name: "安徽省巢湖市庐江县柯桓镇元风欣欣小学", address: "安徽省合肥市庐江县柯坦镇城池小学" },
  { code: 319, name: "四川省江油市中垻镇文化街武林欣欣示范小学", address: "四川省绵阳市江油市中坝镇文化街小学校" },
  { code: 320, name: "陕西省岐山县雍川镇麦禾营欣欣示范中心小学", address: "陕西省宝鸡市岐山县雍川镇麦禾营中心小学" },
  { code: 321, name: "甘肃省定西市陇西县文峰阵镇南九年制欣欣示范学校", address: "甘肃省定西市陇西县文峰阵镇南九年制学校" },
  { code: 322, name: "陕西省咸阳市乾县城关镇张家堡朱保真欣欣完小", address: "陕西省咸阳市乾县城关张家堡小学" },
  { code: 323, name: "黑龙江省齐齐哈尔市富裕县富海镇大化欣欣中心小学", address: "黑龙江省齐齐哈尔市富裕县富海镇中心学校" },
  { code: 324, name: "安徽省金寨县麻埠镇瑞卿欣欣小学", address: "安徽省六安市金寨县麻埠镇实验学校" },
  { code: 325, name: "广西壮族自治区贺州市平桂管理区公会镇茶坪欣欣小学", address: "广西壮族自治区省贺州市平桂区公会镇茶坪小学" },
  { code: 326, name: "陕西省汉中市洋县龙亭镇创立克欣欣中心", address: "陕西省汉中市洋县龙亭镇中心小学" },
  { code: 327, name: "陕西省旬阳县铜钱关镇方肇亨欣欣中心学校", address: "陕西省安康市旬阳县铜钱关镇中心学校" },
  { code: 328, name: "安徽省肥西县铭传乡李国彝欣欣小学", address: "安徽省合肥市肥西县铭传学校" },
  { code: 329, name: "宁夏回族自治区吴中市同心县预旺镇土峰自强欣欣小学", address: "宁夏回族自治区吴忠市同心县预旺镇土峰完全学校" },
  { code: 330, name: "江西省宜丰县棠浦镇塘岭凯文欣欣小学", address: "江西省宜春市宜丰县棠浦镇塘岭小学" },
  { code: 331, name: "陕西省兴平市东城街道办事处东关小学", address: "陕西省咸阳市兴平市东城街道办事处东关小学" },
  { code: 332, name: "湖南省临澧县四星岗镇斋阳欣欣小学", address: "湖南省常德市临澧县四新岗镇斋阳小学" },
  { code: 333, name: "四川广元市平溪乡飞翔欣欣小学", address: "四川省广元市朝天区曾家镇第二小学" },
  { code: 334, name: "黑龙江省齐齐哈尔市龙江县山泉镇阳光欣欣中心小学", address: "黑龙江省齐齐哈尔市龙江县山泉镇中心小学" },
  { code: 335, name: "江苏省高邮市卫楣欣欣小学", address: "江苏省扬州市高邮市汤庄镇汉留小学" },
  { code: 339, name: "黑龙江省牡丹江市海南朝鲜族乡林美英欣欣中心小学", address: "黑龙江省牡丹江市海南朝鲜族乡汉族中心校" },
  { code: 340, name: "吉林市龙潭区缸窑镇欣欣小学", address: "吉林省吉林市龙潭区缸窑镇中心小学" },
  { code: 341, name: "江西省宜丰县潭山镇欣欣中心小学", address: "江西省宜春市宜丰县潭山镇中心小学" },
  { code: 342, name: "甘肃省瓜州县秀廷欣欣中心小学", address: "甘肃省酒泉市瓜州县腰站子东乡族镇中心小学" },
  { code: 343, name: "甘肃省敦煌市转渠口镇定西孙立欣欣小学", address: "甘肃省酒泉市敦煌市转渠口镇中心小学" },
  { code: 344, name: "江西省宜春市温汤镇欣欣学校", address: "江西省宜春市明月山区温汤镇中心小学" },
  { code: 345, name: "山西清徐县孟封镇齐南安尚琳欣欣小学", address: "山西省太原市清徐县孟封镇齐南安小学校" },
  { code: 346, name: "湖北省黄冈市黄梅县五祖镇思源学校", address: "湖北省黄冈市黄梅县五祖镇思源学校" },
  { code: 347, name: "山东沂南县双堠镇南石门中心小学", address: "山东省临沂市沂南县双堠镇石门中心小学" },
  { code: 348, name: "江西省上饶市广信区昌琪欣欣小学", address: "江西省上饶市广信区黄沙岭乡蔡家村小学" },
  { code: 349, name: "贵州省纳雍县玉龙坝镇霞音欣欣小学", address: "贵州省毕节市纳雍县玉龙坝镇果比小学" },
  { code: 350, name: "四川省美姑县哈洛乡莘幸欣欣小学", address: "四川省凉山彝族自治州哈洛乡小学校" },
  { code: 351, name: "湖南省永兴县大布江浩咏欣欣小学", address: "湖南省郴州市永兴县大布江中心学校" },
  { code: 352, name: "湖北省兴山县叶开泰欣欣中心小学", address: "湖北省宜昌市兴山县榛子乡中心小学" },
  { code: 353, name: "湖南省娄底市新化县荣华乡慕贞欣欣小学", address: "湖南省娄底市新化县荣华乡田果小学" },
  { code: 354, name: "湖南省祁阳县下马渡镇梅芙欣欣中心小学", address: "湖南省永州市祁阳市下马渡镇中心小学" },
  { code: 355, name: "湖南省平江县眉秋欣欣小学", address: "湖南省岳阳市平江县伍市镇白杨小学" },
  { code: 356, name: "湖南省江华瑶族自治县梅吉仁欣欣小学", address: "湖南省永州市江华瑶族自治县大路铺镇仙石完全小学" },
  { code: 358, name: "河北省平乡县风鹏欣欣小学", address: "河北省邢台市平乡县田付村乡艾村小学" },
  { code: 359, name: "河北省赞皇县袁励准欣欣中心小学", address: "河北省石家庄市赞皇县许亭乡许亭中心小学" },
  { code: 360, name: "江苏省灌云县陈铁凡欣欣特殊教育学校", address: "江苏省连云港市灌云县伊山镇特殊教育学校" },
  { code: 361, name: "福建省周宁县玛坑乡丽云欣欣学校", address: "福建省宁德市周宁县玛坑乡中心小学" },
  { code: 362, name: "四川省雅安市宝兴县硗碛藏族丽云欣欣学校", address: "四川省雅安市宝兴县硗碛藏族九年一贯制学校" },
  { code: 363, name: "河北省盐山县范庄欣欣小学", address: "河北省沧州市盐山县盐山镇范庄中心小学" },
  { code: 364, name: "四川省广元市剑阁县文勇欣欣小学", address: "四川省广元市剑阁县木马镇柏垭小学校" },
  { code: 365, name: "湖南省常德市石门县子良镇尚琳欣欣小学", address: "湖南省常德市石门县子良镇中心学校" },
  { code: 366, name: "湖南省中方县世渊欣欣小学", address: "湖南省怀化市中方县中方镇金光大道莉坪社区西北210米" },
  { code: 367, name: "湖南省石门县为华欣欣小学", address: "湖南省常德市石门县皂市镇" },
  { code: 368, name: "江苏省扬州市宝应县西安丰镇欣欣小学", address: "江苏省扬州市宝应县西安丰镇兴安路296号" },
  { code: 9002, name: "四川省成都市大邑县晋原镇银屏乡锦屏村子龙街小学欣欣阅览室", address: "四川省成都市银屏乡锦屏村子龙街小学" },
  { code: 9003, name: "四川省成都市大邑县悦来镇鹤庆村悦来镇学校欣欣阅览室", address: "四川省成都市鹤庆村悦来镇学校" },
  { code: 9004, name: "陕西省汉中市洋县洋州镇南街小学欣欣阅览室", address: "陕西省汉中市洋县南街小学" },
  { code: 9005, name: "陕西省渭南市富平县淡村镇仲勋学校欣欣阅览室", address: "陕西省渭南市富平县淡村镇仲勋学校" },
  { code: 9006, name: "四川省成都市大邑县晋原镇北街小学欣欣阅览室", address: "四川省成都市大邑县晋原镇北街小學" },
  { code: 9007, name: "甘肃省定西市安定区公园路小学 欣欣阅览室", address: "甘肃省定西市安定区公园路小学" },
  { code: 9008, name: "甘肃省天水市秦州区太京镇窝驼学校 欣欣阅览室", address: "甘肃省天水市秦州區太京镇窝驼學校" },
  { code: 10044, name: "湖南湘西凤凰县禾库镇广恩欣欣小学", address: "湖南省湘西州凤凰县禾库学区龙角教学点" },
  { code: 10047, name: "湖南省长沙县白沙乡杨隆佑一小", address: "湖南省长沙市开慧镇灵佑庙小学" },
  { code: 10074, name: "江苏省宝应县芦村乡居秉溶欣欣小学", address: "江苏省扬州市宝应县柳堡镇芦村小学" },
  { code: 10110, name: "四川南充市嘉陵区郑家沟联合村林氏欣欣小学", address: "四川省南充市嘉陵区太和乡小学" },
  { code: 10115, name: "湖北孝感县杨店镇徐建萍欣欣小学", address: "湖北省孝感市孝南区杨店镇陈集小学" },
  { code: 10146, name: "湖北省钟祥双河镇丁坪村李济博士伉俪纪念欣欣小学", address: "湖北省荆门市钟祥市双河镇丁坪小学" },
  { code: 10153, name: "四川雅安市宝兴县穆坪镇林荣欣欣小学", address: "四川省雅安市宝兴县穆坪镇林荣欣欣小学" },
  { code: 10158, name: "江西省共青城金湖镇欣欣小学", address: "江西省九江市共青城金湖镇中心小学" },
  { code: 10181, name: "湖南省岳阳市平江县长寿镇新民欣欣完小", address: "湖南省岳阳市平江县长寿镇永联学校" },
  { code: 10184, name: "江西省抚州市旁安尊朴欣欣小学", address: "江西省抚州市旁安尊朴欣欣小学" },
  { code: 10288, name: "山东省济宁市微山县留庒镇鸿恩欣欣小学", address: "山东省济宁市微山县留庄镇英才小学" },
  { code: 10305, name: "湖北省鄂州市华容区蒲团乡上倪欣欣小学", address: "湖北省鄂州市华容区蒲团乡上倪小学" },
  { code: 10306, name: "湖北省黄冈市英山县孔家坊乡瑞兰欣欣中心小学", address: "湖北省黄冈市英山县孔家坊乡中心小学" },
  { code: 10324, name: "安徽省金寨县齐山瑞卿欣欣小学", address: "安徽省六安市金寨县麻埠镇齐山教学点" },
  { code: 10340, name: "吉林省舒兰市谭家村育宜欣欣小學", address: "吉林省吉林市舒兰市莲花乡谭家村小学" },
  { code: 10344, name: "江西省宜春市社埠文泉欣欣完小", address: "江西省宜春市明月山温泉风景名胜区温汤镇" },
  { code: 10346, name: "湖北省黄梅县张思永凯文欣欣小学", address: "湖北省黄冈市黄梅县五祖镇张思永小学" },
  { code: 10347, name: "山东齐鲁会馆欣欣小学", address: "山东省临沂市沂南县双堠镇龙口小学" },
  { code: 20001, name: "黑龙江哈尔滨市双城区第八小学校", address: "黑龙江省哈尔滨市双城区第八小学校" },
  { code: 20002, name: "湖南省平江县龙门镇土龙小学", address: "湖南省岳阳市平江县龙门镇土龙小学" },
  { code: 20003, name: "吉林省辽源市西安区灯塔镇中心小学", address: "吉林省辽源市西安区灯塔镇中心小学" },
  { code: 20004, name: "吉林省白城市通榆县瞻榆镇义慈小学校", address: "吉林省白城市通榆县瞻榆镇义慈小学校" },
  { code: 20005, name: "甘肃省玉门市小金湾乡学校", address: "甘肃省酒泉市玉门市小金湾乡学校" },
  { code: 20007, name: "四川省凉山州美姑县瓦候乡小学校", address: "四川省凉山州美姑县瓦候乡小学校" },
  { code: 20010, name: "黑龙江哈尔滨市双城区胜丰镇中心学校胜业分校", address: "黑龙江哈尔滨市双城区胜丰镇第二中学校胜业分校" },
  { code: 20011, name: "黑龙江省哈尔滨市双城区朝阳乡第一中学", address: "黑龙江省哈尔滨市双城区朝阳乡第一中学" },
  { code: 20158, name: "江西省南昌市新建区大塘坪乡中心小学", address: "江西省南昌市新建区大塘坪乡中心小学" },
  { code: 20218, name: "湖北黄石市阳新县经济开发区滑石小学", address: "湖北黄石市阳新县经济开发区滑石小学" },
  { code: 20274, name: "山西省晋中市榆次区庄子乡欣欣小学", address: "山西省晋中市榆次区庄子乡中心小学" },
  { code: 20500, name: "甘肃省白银市靖远县大芦镇大芦中心小学", address: "甘肃省白银市靖远县大芦镇大芦中心小学" },
  { code: 20501, name: "甘肃省白银市靖远县大芦镇浙江卡森希望小学", address: "甘肃省白银市靖远县大芦镇浙江卡森希望小学" },
  { code: 20502, name: "甘肃省兰州市七里河区王官营小学", address: "甘肃省兰州市七里河区王官营小学" },
  { code: 20503, name: "甘肃省兰州市七里河区陶家沟小学", address: "甘肃省兰州市七里河区陶家沟小学" },
  { code: 20504, name: "黑龙江省哈尔滨市双城区教师进修学校", address: "黑龙江省哈尔滨市双城区教师进修学校" },
  { code: 20505, name: "黑龙江省哈尔滨市双城区中小学生综合实践学校", address: "黑龙江省哈尔滨市双城区中小学生综合实践学校" },
  { code: 20506, name: "黑龙江省齐齐哈尔市甘南县第四小学", address: "黑龙江省齐齐哈尔市甘南县第四小学" },
  { code: 20507, name: "黑龙江省齐齐哈尔市甘南县平阳镇中心学校", address: "黑龙江省齐齐哈尔市甘南县平阳镇中心学校" },
  { code: 20508, name: "黑龙江省齐齐哈尔市甘南县实验小学", address: "黑龙江省齐齐哈尔市甘南县实验小学" },
  { code: 20509, name: "黑龙江省齐齐哈尔市甘南县兴十四学校", address: "黑龙江省齐齐哈尔市甘南县兴十四学校" },
  { code: 20510, name: "湖南省湘西州保靖县吕洞山镇夯沙九年一贯制学校", address: "湖南省湘西州保靖县吕洞山镇夯沙九年一贯制学校" },
  { code: 20511, name: "湖南省湘西州保靖县毛沟镇芙蓉学校", address: "湖南省湘西州保靖县毛沟镇芙蓉学校" },
  { code: 20512, name: "湖南省湘西州保靖县涂乍乡涂乍小学", address: "湖南省湘西州保靖县涂乍乡涂乍小学" },
  { code: 20513, name: "湖南省湘西州花垣县第三中学", address: "湖南省湘西州花垣县第三中学" },
  { code: 20514, name: "湖南省湘西州花垣县麻栗场镇中心小学", address: "湖南省湘西州花垣县麻栗场镇中心小学" },
  { code: 20515, name: "江西省萍乡市上栗县杨岐乡石岭小学", address: "江西省萍乡市上栗县杨岐乡石岭小学" },
  { code: 20516, name: "江西省萍乡市上栗县杨岐乡文岐小学", address: "江西省萍乡市上栗县杨岐乡文岐小学" },
  { code: 20517, name: "江西省萍乡市上栗县杨岐乡中心小学", address: "江西省萍乡市上栗县杨岐乡中心小学" },
  { code: 20518, name: "山东省济宁市曲阜市王庄镇康桥小学", address: "山东省济宁市曲阜市王庄镇康桥小学" },
  { code: 20519, name: "山东省济宁市曲阜市王庄镇纸坊小学", address: "山东省济宁市曲阜市王庄镇纸坊小学" },
  { code: 20520, name: "山东省烟台市长岛海洋生态文明综合试验区北长山乡中心小学", address: "山东省烟台市长岛海洋生态文明综合试验区北长山乡中心小学" },
  { code: 20521, name: "四川省松潘县白羊九年一贯制小学", address: "四川省松潘县白羊九年一贯制小学" },
  { code: 20522, name: "黑龙江省哈尔滨市双城区万隆乡中心学校", address: "黑龙江省哈尔滨市双城区万隆乡中心学校" },
  { code: 20523, name: "黑龙江省哈尔滨市双城区韩甸镇中心学校", address: "黑龙江省哈尔滨市双城区韩甸镇中心学校" },
  { code: 20524, name: "黑龙江省哈尔滨市双城区第九小学校", address: "黑龙江省哈尔滨市双城区第九小学校" },
  { code: 20525, name: "甘肃省白银市靖远县大芦镇纤纤爱心小学", address: "甘肃省白银市靖远县大芦镇纤纤爱心小学" },
  { code: 20526, name: "甘肃省临夏州临夏市南龙镇南川小学", address: "甘肃省临夏州临夏市南龙镇南川小学" },
  { code: 20527, name: "黑龙江省齐齐哈尔市甘南县兴隆乡中心学校", address: "黑龙江省齐齐哈尔市甘南县兴隆乡中心学校" },
  { code: 20528, name: "黑龙江省齐齐哈尔市甘南县甘南镇中心学校", address: "黑龙江省齐齐哈尔市甘南县甘南镇中心学校" },
  { code: 20529, name: "江西省萍乡市上栗县杨岐乡黄冲小学", address: "江西省萍乡市上栗县杨岐乡黄冲小学" },
  { code: 20530, name: "河北省邯郸市魏县北皋镇杨柴曲中心小学", address: "河北省邯郸市魏县北皋镇杨柴曲中心小学" },
  { code: 20531, name: "江西省新余市分宜县第一中心小学", address: "江西省新余市分宜县第一中心小学" },
  { code: 20532, name: "江西省新余市分宜县第二中心小学", address: "江西省新余市分宜县第二中心小学" },
  { code: 20533, name: "黑龙江省哈尔滨市双城区兆麟小学", address: "黑龙江省哈尔滨市双城区兆麟小学" },
];

export const findSchoolByCode = (code) => SCHOOLS.find((s) => String(s.code) === String(code));

// react-select's default filterOption only matches against an option's
// `label` (the school name) -- with hundreds of similarly-named schools,
// that leaves no way to search by the school code or address shown
// alongside the name (see formatSchoolOptionLabel in the components using
// this), so searching e.g. a known school code returned no results.
// `option.data` is react-select's own reference to the original
// { value, label, address } object passed in via `options`, so this matches
// partially (case-insensitively) against all three fields instead of label
// alone. Shared by every school Select (register/admin-users-list/profile)
// rather than duplicated per component.
export const schoolFilterOption = (option, rawInput) => {
  const input = rawInput.trim().toLowerCase();
  if (!input) return true;
  const { value, label, address } = option.data;
  return [value, label, address].some((field) => field != null && String(field).toLowerCase().includes(input));
};
